<template>
  <div class="flex flex-col gap-3">
    <ship-card
      v-for="(card, index) in categoryCards"
      :key="index"
      @click="openShipDrawer(card)"
      :selected="currentTab === index"
      :name="card.name"
      :description="card.description"
      :level="card.level"
      :price="card.upgrade_price || card.buy_price"
      :profit="card.token_per_hour"
      :image="card.image"
    ></ship-card>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { openBottomDrawer } from '@/composables/bottomdrawer'

import ShipCard from './ShipCard.vue'
import ShipDrawer from './drawers/ShipDrawer.vue'
import { useConstantStore } from '@/stores/constant';

const constantStore = useConstantStore()

const props = defineProps({
  cards: {
    type: Array,
    required: false
  },
  category: {
    type: String,
    required: true
  }
})

const categoryCards = computed(() => constantStore.getCategoryCards(props.category))

const openShipDrawer = (itemInfo) => {
  openBottomDrawer(ShipDrawer, {
    props: { itemInfo: itemInfo },
    emits: {},
    size: 'md'
  })
}


</script>

<style></style>
